package com.mps.asc_app.data.bookings

interface BookingsRepository {
    suspend fun getBookingsForTimeslot(
        id: String,
        startEpochMillis: Long
    ): Bookings?

    suspend fun getBookingsForDay(
        courtId: String,
        dayStartEpochMillis: Long,
        dayEndEpochMillis: Long
    ): List<Bookings>

    suspend fun countFutureBookingsForUser(
        userId: String,
        nowEpochMillis: Long
    ): Int

    suspend fun getFutureBookingsForUser(
        userId: String,
        userEmail: String? = null,
        nowEpochMillis: Long,
        limit: Int = 10,
    ): List<Bookings>

    suspend fun createBooking(
        bookingId: String,
        courtId: String,
        slotEpochMillis: Long,
        userId: String,
        displayNameSnapshot: String?,
        bookingScope: BookingScope = BookingScope.SELF,
        trainingGroupId: String? = null,
    ): Boolean

    /**
     * Admin-Funktion: blockiert einen Slot mit Kommentar, indem ein Booking-Dokument mit kind=BLOCKED angelegt wird.
     * @return false, wenn der Slot bereits belegt/gesperrt ist.
     */
    suspend fun blockSlot(
        bookingId: String,
        courtId: String,
        slotEpochMillis: Long,
        adminUserId: String,
        comment: String,
        trainingGroupId: String? = null,
        recurringRule: String? = null,
    ): Boolean

    suspend fun blockRecurringSlots(
        entries: List<RecurringBlockEntry>,
        actorUserId: String,
        comment: String,
        trainingGroupId: String? = null,
    ): Int

    /**
     * Admin-Funktion: hebt eine Sperre wieder auf (löscht das Dokument), wenn es kind=BLOCKED ist.
     */
    suspend fun unblockSlot(
        bookingId: String,
    ): Boolean

    suspend fun cancelBooking(
        bookingId: String,
        userId: String
    ): Boolean
}

data class RecurringBlockEntry(
    val bookingId: String,
    val courtId: String,
    val slotEpochMillis: Long,
    val recurringRule: String,
)
